/**
 * Long-lived AWS SDK clients memoize the first temporary credentials returned
 * by their provider. Amplify clears its own cache on sign-out, but it cannot
 * reach those client-local copies. Credential-bound services register here so
 * the app's auth lifecycle can invalidate them as one session boundary.
 */
const m_resetters = new Set<() => void>();

export function registerAwsCredentialClientReset(reset: () => void): () => void {
  m_resetters.add(reset);
  return () => m_resetters.delete(reset);
}

export function resetAwsCredentialClients(): void {
  for (const reset of m_resetters) reset();
}
